import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import cx from 'classnames'
import { useNavigate } from 'react-router'

import { useAnnotations } from '../../../hooks/annotation/useAnnotations'
import { getAnnotationGroups } from '../../../hooks/annotation/utils'
import { useHook } from '../../../lenteHooks'
import { generalRoutes } from '../../../routing/generalRoutes'
import { findMemberIcon } from '../../memberInfo/utilities'

type MemberIconProps = {
  highlightClassName?: string
}

export const MemberIcon = ({ highlightClassName }: MemberIconProps) => {
  const translateEnum = useTranslateEnum()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  const navigate = useNavigate()

  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )({
    tenantId,
    personId: ownerId,
  })

  const annotations = useAnnotations({
    businessType: 'person',
    shouldSkipSpecificFetches: false,
  })
  const annotationGroups = getAnnotationGroups(annotations).sort(
    (left, right) => left.localeCompare(right),
  )
  const hasAnnotationRoles = annotationGroups.length > 0

  const gender = personVersion?.gender

  return (
    <div className="relative size-14">
      <img
        src={findMemberIcon(gender)}
        title={translateEnum('life.enum.Gender', gender)}
        className={cx(
          'size-14 rounded-full',
          hasAnnotationRoles && highlightClassName,
        )}
      />
      {annotationGroups.length > 0 ? (
        <div
          className="absolute right-0 bottom-0 z-20 translate-x-1/5 translate-y-1/5 cursor-pointer"
          role="button"
          tabIndex={0}
          aria-label={annotationGroups.join(', ')}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              event.currentTarget.click()
            }
          }}
          onClick={async () => {
            await navigate(
              generalRoutes.annotation.person({
                ownerId,
                tenantId,
              }),
            )
          }}
        >
          <Tooltip
            placement="right"
            tip={
              <div className="flex min-w-32 flex-col gap-1">
                {annotationGroups.map((group) => (
                  <span key={group}>{group}</span>
                ))}
              </div>
            }
          >
            <span
              aria-label={annotationGroups.join(', ')}
              className="flex size-5 items-center justify-center rounded-full border-2 border-white bg-sky-600 text-[10px] font-semibold text-white shadow-sm"
            >
              V
            </span>
          </Tooltip>
        </div>
      ) : null}
    </div>
  )
}
